// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I24o","delete":"styles_delete__2oHq2","update":"styles_update__3fMxL","add":"styles_add__25KKz"};